module.exports = __webpack_public_path__ + "static/media/thibault-sponsor.f6851e24.png";